export default "/images/126f38eb1b77c1c5eff071ea15df41c6.avif";